/**
 * WebKit no iPhone emite NotReadableError sem stack quando um XHR/fetch
 * morre no meio (aba em background, rádio dormindo, sessão caindo).
 * O Axios já trata isso como Network Error; a rejeição nativa chega solta
 * em onunhandledrejection (DR-ORNELLAS-25H).
 *
 * Falha real de FileReader no app tem frame in_app e continua sendo enviada.
 */
export function isBenignIosNotReadableError(event) {
  const exception = event?.exception?.values?.[0];
  if (!exception) return false;

  const isNotReadable =
    exception.type === 'NotReadableError' ||
    String(exception.value || '').includes('The I/O read operation failed');

  if (!isNotReadable) return false;

  const frames = exception.stacktrace?.frames;
  const hasAppFrame = Array.isArray(frames) && frames.some((frame) => frame.in_app);

  return !hasAppFrame;
}
